<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="客户：">
            <label slot="label">客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：</label>
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" :clearable="true">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
            <el-button size="medium" type="primary" plain @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="TC_NAME" label="团餐公司" min-width="200"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="150"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="60"></el-table-column>
          <el-table-column prop="CURRENT_BEFORE_TAX_PRICE" label="当期价格" min-width="150"></el-table-column>
          <el-table-column prop="NEXT_BEFORE_TAX_PRICE" label="下期价格" min-width="150"></el-table-column>
          <el-table-column prop="NEXT_EFFECTIVE_DATE" label="下期生效日期" min-width="150"></el-table-column>
          <el-table-column prop="OPERATE_TIME" label="操作时间" min-width="150"></el-table-column>
          <el-table-column prop="LAST_OPERATION_USER_NAME" label="操作人" min-width="150"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getEnteyCusFun, selectTCFun } from 'api/sellOrder';
import { supplierCusFun } from 'api/customerManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loadSearch: false,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      companys: [],
      tableData: [],
      searchForm: {
        TC_COMPANY: '',
      },
      formLabelWidth: '120px',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (this.CUSTOMER_PRICING_REVIEW_CONDITION.CONDITION) {
      this.searchForm = this.CUSTOMER_PRICING_REVIEW_CONDITION.CONDITION;
      this.currentPage = this.CUSTOMER_PRICING_REVIEW_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryCustomer();
    this.queryTable();
  },
  computed: {
    CUSTOMER_PRICING_REVIEW_CONDITION() {
      return this.$store.state.CUSTOMER_PRICING_REVIEW_CONDITION;
    },
  },
  methods: {
    // 选择客户
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = this.$util.listRemoveDuplicates(result[0].company);
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.name && this.searchForm.name != '') {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code && this.searchForm.code != '') {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      this.loadSearch = true;
      http.post(params)
        .then((result) => {
          this.tableData = result.LIST;
          this.totalCount = result.TOTAL_COUNT;
          this.$store.dispatch('SET_CUSTOMER_PRICING_REVIEW_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
          this.loadSearch = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loadSearch = false;
        });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 8,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.name && this.searchForm.name != '') {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code && this.searchForm.code != '') {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      http.post(params)
        .then((result) => {
          if (result[0]) {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.$message.show({ text: '导出成功', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/customerPricingReview.vue